module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00042-fs8.67db22b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00042-fs8.png
// module id = 195
// module chunks = 0